// import { use } from 'react';
import { useContext } from 'react';
import { PageTransitionProviderContext } from './PageTransitionProvider';

// use 'use' over 'useContext' after migration to app router is complete or after switching to react 19 is processed, because for now 'use' is only available in the app router
// export const usePageTransition = () => use(PageTransitionProviderContext);

export const usePageTransition = () => useContext(PageTransitionProviderContext);
